<template>
  <div class="certificate">
    <div class="row mb-4">
      <w-radio-list class="col-12" :model="schema.actionType" :values="actionTypes" @input="setPreviousCertificate" />
    </div>

    <div class="row mb-4">
      <w-input class="col-6" :model="schema.numberOfCertificate" />

      <w-datepicker class="col-6" :model="schema.certificateDate" />
    </div>

    <h3>{{ schema.department.$title }}</h3>

    <div class="row mb-4">
      <w-input class="col-6" :model="schema.department.name" />

      <w-input class="col-6" :model="schema.department.nip" />

      <w-textarea class="col-12" :model="schema.department.address" />
    </div>

    <h3>{{ schema.tenderer.$title }}</h3>

    <div class="row mb-3">
      <w-input class="col-6" :model="schema.tenderer.displayName" />

      <w-input class="col-6" :model="schema.tenderer.nip" />

      <address-form class="col-12" :model="schema.tenderer.address" />
    </div>

    <div class="row mb-4">
      <w-radio-list class="col-12 mb-3" :model="schema.isCompanyPartner" :values="isCompanyPartnerOptions" />

      <w-input class="col-6" :model="schema.companyPartner.name" />

      <w-input class="col-6" :model="schema.companyPartner.nip" />

      <address-form class="col-12" :model="schema.companyPartner.address" />
    </div>

    <div class="row mb-4">
      <w-wysiwyg class="col-12 legal-basis" :model="schema.legalBasis" :height="100" />
    </div>

    <h3>Kwoty</h3>

    <div class="row mb-4">
      <w-input class="col-6" :model="schema.amount" />

      <w-input class="col-6" :model="schema.euroAmount" />
    </div>

    <h3>{{ schema.issuer.$title }}</h3>

    <div class="row mb-4">
      <w-input class="col-6" :model="schema.issuer.firstName" />

      <w-input class="col-6" :model="schema.issuer.lastName" />

      <w-input class="col-6" :model="schema.issuer.position" />

      <w-wysiwyg class="col-12 signature" :model="schema.issuer.signature" :height="100" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import AddressForm from '@/components/forms/document/Address.vue';
import { DocumentValueCodes } from '@/enums/documentValueCodes.enum';

export default {
  components: { ...components, AddressForm },
  props: {
    schema: { type: Object, required: false }
  },
  data() {
    const actionTypes = [
      { value: 1, text: 'Wydanie zaświadczenia' },
      { value: 2, text: 'Korekta zaświadczenia' }
    ];

    const isCompanyPartnerOptions = [
      { text: 'Dotyczy', value: true },
      { text: 'Nie dotyczy', value: false }
    ];

    return {
      actionTypes,
      isCompanyPartnerOptions
    };
  },

  methods: {
    setPreviousCertificate() {
      const actionType = this.schema.actionType.$model;
      const values = this.schema._options.external.document && this.schema._options.external.document.values;
      if (actionType === 2 && values) {
        this.$nextTick(() => {
          this.schema.certificateDate.$setData(values[DocumentValueCodes.CERTIFICATE_DATE]);
          this.schema.numberOfCertificate.$setData(values[DocumentValueCodes.CERTIFICATE_NUMBER]);
        });
      }
    }
  }
};
</script>

<style>
.certificate .row .form-control {
  margin-bottom: 1 rem;
}

.certificate .signature textarea {
  min-height: 100px;
}
</style>
